export default {
  isSet: state => {
    return ![state.marketing, state.personalization, state.analytics].includes(null)
  },
  allCookiesAccepted: state => {
    return (state.marketing && state.personalization && state.analytics)
  }
}